module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//lost.png?v=dfd7430c";